import React, { useState } from 'react';
import { Button, Divider, Dialog, DialogActions, DialogTitle, DialogProps, DialogContent, TextField, Grid, makeStyles, Typography } from '@material-ui/core';
import axios from 'axios';
import settings from '../../settings';
import { useNotification } from '../../contexts/Notification';


const useStyles = makeStyles((theme) => ({
	img: {
		width: '100%'
	},
	helperText: {
		fontSize: 12,
		margin: 'auto'
	}
}));

interface StrapiMediaPopupProps extends DialogProps {
type?: "video" | "image" | "all",
	open: boolean,
	onClose: (n?: any) => void
};

const StrapiMediaPopup = (props: StrapiMediaPopupProps) => {
	const classes = useStyles();
	const [image, setImage] = useState<any>(null);
	const [title, setTitle] = useState<string>("");
	const [credit, setCredit] = useState<string>("");
	const notification = useNotification();

	return (
		<Dialog open={props.open} onClose={props.onClose}>
			<DialogTitle>
				Importer une nouvelle {props.type}
			</DialogTitle>
			<DialogContent>
				<Grid container direction="column">
					<p>Title:</p>
					<TextField value={title} onChange={(e) => {
						setTitle(e.target.value);
					}} />
					<p>Crédit</p>
					<TextField value={credit} onChange={(e) => {
						setCredit(e.target.value);
					}} />
					<Divider />
					<Button>
						<input type="file" name="file" onChange={(e) => {
							if (e.target) {
								setImage(e.target.files![0]);
							}
						}} />
					</Button>
					{props.type === "video" && <Typography className={classes.helperText}>Format de vidéo recommandé: .mp4</Typography>}
					{image && <img src={URL.createObjectURL(image)} alt='to upload' className={classes.img}/>}
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => {
					const formData = new FormData();
					formData.append("files", image);
					formData.append("fileInfo", JSON.stringify({ alternativeText: title, caption: credit }));
					axios.post(settings.strapiUrl + "upload", formData,
						{
							headers: {
								'Content-Type': 'multipart/form-data'
							}
					})
					.then((r) => {
						notification.notify("Media Importé", "success");
						console.log(r.data[0]);
						props.onClose(r.data[0]);
					}).catch((e) => {
						notification.notify("Error lors de l'import", "error");
					});
				}}>Import</Button>
				<Button onClick={() => {setImage(null); props.onClose()}}> 
					close
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default StrapiMediaPopup;